import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function NewsHighlight() {
  const [featured, ...rest] = newsList.slice(0, 5);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <Link
        to={`/news/${featured.id}`}
        className="group block rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
          <img
            src={featured.cover}
            alt={featured.title}
            title={`${featured.title} 资讯配图`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
            {featured.category}
          </span>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
            {featured.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-500 line-clamp-2">{featured.summary}</p>
          <p className="mt-3 text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {featured.date}
          </p>
        </div>
      </Link>

      <div className="flex flex-col divide-y divide-background-200 border border-background-200 rounded-lg overflow-hidden">
        {rest.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="group flex items-start gap-4 p-4 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <span className="w-20 h-14 md:w-24 md:h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} 资讯配图`}
                className="w-full h-full object-cover object-top"
              />
            </span>
            <div className="min-w-0">
              <h3 className="text-sm font-medium text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                {item.title}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-400 flex items-center gap-2">
                <span className="text-secondary-700">{item.category}</span>
                <span>{item.date}</span>
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}